import {IOnChanges, IOnChangesObject} from "angular";
import {Optional} from "../../../../js/util/Optional";
import {PriceStrategyService} from "../../../inputs/price/service/PriceStrategyService";
import {PriceStrategy} from "../../../inputs/price/input/PriceStrategy";
import {OptionsTicket} from "../../../../portfolio/templates/ticket/types/OptionsTicket";

export const TradeLimit = "tfTradeDetailLimit";

export function tradeLimit() {
    return {
        template,
        bindings: {
            trade: "<",
            currentChildLimit: "<",
            allowZero: "<",
            hideMidButton: "<",
            onMidClick: "&",
            onChange: "&",
        },
        controller: TradeLimitController,
        controllerAs: "ctrl"
    };
}

export class TradeLimitController implements IOnChanges {

    public readonly trade: OptionsTicket;
    public currentChildLimit: number | undefined;
    public readonly allowZero: boolean | undefined;
    public readonly onMidClick: Function;
    public readonly onChange: Function;

    public hideMidButton: boolean | undefined;

    public strategy: PriceStrategy;

    private strategyService: PriceStrategyService;

    /** @ngInject */
    public constructor(priceStrategyService: PriceStrategyService) {
        this.strategyService = priceStrategyService;
    }

    public $onChanges(changes: IOnChangesObject): void {
        if (changes.trade != null && this.trade != null) {
            const code = Optional.of(this.trade.code)
                                 .orElseGet(() => this.trade.code);
            this.strategy = this.strategyService.forCode(code);
        }
    }

    public setToMid() {
        this.onMidClick();
    }

    public priceChanged(price: number) {
        if (this.currentChildLimit !== undefined) {
            this.currentChildLimit = price;
        } else {
            this.trade.limit = price;
        }
        this.onChange({limit: price});
    }
}

const template = `
    <div class="row form-group">
        <label class="col-xs-12 col-sm-3 col-md-2 control-label" translate="order.LIMIT"></label>
        <div ng-class="(ctrl.hideMidButton | async : this) !== true ? 'col-xs-10 col-sm-7 col-md-8' : 'col-xs-12 col-sm-9 col-md-10' ">
            <tf-price-input name="limit"
                            price="ctrl.currentChildLimit === undefined ? ctrl.trade.limit : ctrl.currentChildLimit"
                            allow-zero="ctrl.allowZero"
                            strategy="ctrl.strategy"
                            min="ctrl.trade.tmc ? null : 0"
                            on-change="ctrl.priceChanged(price)"
                            required="true">
            </tf-price-input>
        </div>
        <div class="col-xs-2" ng-show="(ctrl.hideMidButton | async : this) !== true">
            <button class="btn btn-info btn-no-padding"
                    ng-click="ctrl.setToMid()">
                <i class="icon-file-mid"></i>
            </button>
        </div>
    </div>
`;
